/**
 * Card JS
 */
export const Card = (function () {

  const cardClass = 'myds-card';
  const cardTitle = 'myds-card-title';
  const cardBody = 'mydex-card-body';

  /**
   * Initalise card components
   */
  var init = function ( ) {   
      // Create event listeners for card clicks
      Card.card.click();
      
      // Event listener for filtering a search from the user
      $(".myds-card-filter").keyup(function() {
        filter(this);
      })
     
  }

  var card = {

    /** Navigates to the cards <a> href when clicked */
    click : function () {

      $(`.${cardBody}`).click(function () {

        var cardItem = this.getElementsByTagName('a')[0]
        var url = cardItem.getAttribute("href");
        if(url != ''){
          window.location = url;
        }
    
      });
    },

  }
  /**
   * Function to filter the cards on a page by an input
   * Used in filter.html on an input element
   * Usage: Card.filter(this)
   * @param {*} input 
   */
  var filter = function ( input ) {   
      
      // Get all the cards 
      var cards = document.getElementsByClassName(cardClass);
      
      // If no input value, make sure all cards are shown
      if(!input.value){
        $(cards).show();
        return;
      }
      // Hide all the cards to start with
      $(cards).hide();
      // Filter the cards 
      $(cards).filter(contains( input )).show();
  }
  /**
   * Private function used in the `filter` function
   * @see Card.filter
   * Note this returns a function so that we can use `this` to refer to each element of the $().filter()
   */
  var contains = function (  input ) {

    return function () {
      // Loop every char of the id and update the `id_result` bool on the existance of the query string
      var id_result = false;
      var id = this.getAttribute('id');
      for (let index = 0; index < id.length; index++) {
        id_result = (id.toUpperCase().indexOf(input.value.toUpperCase()) > -1);
      }
      var title = this.getElementsByClassName(cardTitle)[0].innerHTML
      var title_result = false;
      // Loop every char of the title and update the `id_result` bool on the existance of the query string
      for (let index = 0; index < title.length; index++) {
        title_result = (title.toUpperCase().indexOf(input.value.toUpperCase()) > -1);
      }
      return (id_result || title_result);
    }
  }

  return {
    init : init,
    card : card,
    filter: filter
  }

}());



